import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7ea7010c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "detail-panel"
};
const _hoisted_2 = {
  class: "cot"
};
import { reactive, ref, onMounted, watchEffect, watch } from 'vue';
import { useRoute } from 'vue-router';
import router from '@/router';
import Introduction from './components/Introduction';
import FilesDownload from './components/FilesDownload';
import Contact from './components/Contact';
import Catalogue from './components/Catalogue';
import TransferInformation from './components/TransferInformation';
export default {
  __name: 'index',
  props: {
    courseInfo: {
      type: Object,
      default: () => {}
    },
    questionList: {
      type: Array,
      default: () => []
    },
    dialogExecrise: {
      type: Boolean,
      default: false
    }
  },
  emits: ['preExecirse', 'closeExeDialog'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const {
      tab,
      id
    } = useRoute().query;
    const detailTabs = ref();
    const state = reactive({
      activeName: tab || 'introduction',
      dialogExecrise: props.dialogExecrise
    });
    watch(() => props.dialogExecrise, val => {
      state.dialogExecrise = val;
    });
    const preExecirse = resourceId => {
      emit('preExecirse', resourceId);
    };
    const closeExeDialog = () => {
      emit('closeExeDialog');
    };
    const formatTabs = () => {
      return [{
        label: '课程简介',
        name: 'introduction'
      }, {
        label: props.courseInfo.coursePlayType === '0' ? '课程目录' : '课程大纲',
        name: 'catalogue'
      }, {
        label: '资料下载',
        name: 'filesdownload'
      }, {
        label: '报名咨询',
        name: 'contact',
        free: '1'
      }, {
        label: '对公转账',
        name: 'transferInformation',
        free: '1'
      }].filter(d => d.free === props.courseInfo.free || !d.free);
    };
    watchEffect(() => {
      detailTabs.value = formatTabs();
    });
    const handleTabChange = tabName => {
      const newQuery = {
        id,
        tab: tabName.props.name
      };
      router.replace({
        query: newQuery
      });
    };
    onMounted(() => {
      detailTabs.value = formatTabs();
    });
    return (_ctx, _cache) => {
      const _component_el_tab_pane = _resolveComponent("el-tab-pane");
      const _component_el_tabs = _resolveComponent("el-tabs");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_tabs, {
        modelValue: state.activeName,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => state.activeName = $event),
        onTabClick: handleTabChange
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detailTabs.value, item => {
          return _openBlock(), _createBlock(_component_el_tab_pane, {
            key: item.name,
            label: item.label,
            name: item.name
          }, null, 8, ["label", "name"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"]), _createElementVNode("div", _hoisted_2, [state.activeName === 'introduction' ? (_openBlock(), _createBlock(_unref(Introduction), {
        key: 0,
        courseInfo: props.courseInfo
      }, null, 8, ["courseInfo"])) : _createCommentVNode("", true), state.activeName === 'catalogue' ? (_openBlock(), _createBlock(_unref(Catalogue), {
        key: 1,
        courseInfo: props.courseInfo,
        dialogExecrise: state.dialogExecrise,
        questionList: props.questionList,
        onPreExecirse: preExecirse,
        onCloseExeDialog: closeExeDialog
      }, null, 8, ["courseInfo", "dialogExecrise", "questionList"])) : _createCommentVNode("", true), state.activeName === 'contact' ? (_openBlock(), _createBlock(_unref(Contact), {
        key: 2,
        courseInfo: props.courseInfo
      }, null, 8, ["courseInfo"])) : _createCommentVNode("", true), state.activeName === 'transferInformation' ? (_openBlock(), _createBlock(_unref(TransferInformation), {
        key: 3,
        courseInfo: props.courseInfo
      }, null, 8, ["courseInfo"])) : _createCommentVNode("", true), state.activeName === 'filesdownload' ? (_openBlock(), _createBlock(_unref(FilesDownload), {
        key: 4,
        courseInfo: props.courseInfo
      }, null, 8, ["courseInfo"])) : _createCommentVNode("", true)])]);
    };
  }
};